import { Accordion } from "lbh-frontend";
import "@fortawesome/fontawesome-free/css/all.css";
import "@fortawesome/fontawesome-pro/css/all.css";

import axios from "axios";

//activate the start button
document.getElementById("start-button").onclick = function () {
  document.getElementById("location-search").hidden = false;
  document.getElementById("start-button").style.display = "none";
  window.scrollBy(0, 100);
};

// Create a variable for the postcode.
let postcode = document.getElementById("postcode");
//Enter key listener that calls the GetAddressesviaPoxy function
postcode.addEventListener("keyup", (e) => {
  if (e.key == "Enter") {
    GetAddressesViaProxy();
  }
});

//eventlistener for the button
document
  .getElementById("search")
  .addEventListener("click", GetAddressesViaProxy);

//listener for the clear x in the input
postcode.addEventListener("search", (e) => {
  document.getElementById("error_message").innerHTML = "";
  document.getElementById("addresses").innerHTML = "";
  document.getElementById("address-details").innerHTML = "";
  //document.getElementById("show-results-button-div").innerHTML = "";
  document.getElementById("results").innerHTML = "";
});

function GetAddressesViaProxy() {
  document.getElementById("error_message").innerHTML = "";
  document.getElementById("addresses").innerHTML =
    '<p class="loading-text"> Loading addresses...</p>';
  document.getElementById("address-details").innerHTML = "";
  //document.getElementById("show-results-button-div").innerHTML = "";
  document.getElementById("results").innerHTML = "";
  document.getElementById("addresses").scrollIntoView({ block: "nearest" });

  //Get the postcode value
  let address_input = document.getElementById("postcode").value;

  //test against postcode regex
  let postcode_regex = new RegExp(
    "^([A-Za-z][A-Ha-hJ-Yj-y]?[0-9][A-Za-z0-9]? ?[0-9][A-Za-z]{2}|[Gg][Ii][Rr] ?0[Aa]{2})$",
  );
  let isPostcode = postcode_regex.test(address_input);
  let results = null;

  if (!address_input) {
    document.getElementById("error_message").innerHTML =
      "Please enter some text in the location search.";
  } else {
    //prepare query to send to the API, depending if we ave got a postcode or not
    let APIQueryString = "";
    if (isPostcode) {
      APIQueryString = `${process.env.ADDRESSES_API_PROXY_PROD}?format=detailed&usage_code=C,X,LP02&postcode=${address_input}`;
    } else {
      APIQueryString = `${process.env.ADDRESSES_API_PROXY_PROD}?format=detailed&usage_code=C,X,LP02&query=${address_input}`;
    }
    //First call to get the list of addresses from a postcode
    fetch(APIQueryString, {
      method: "get",
    })
      .then((response) => response.json())
      .then((data) => {
        //Get API error messages if the UPRN values are not right
        if (data.data.errors) {
          document.getElementById("error_message").innerHTML =
            response.data.errors[0].message;
          document.getElementById("addresses").innerHTML = "";
          //If there are no errors...
        } else {
          results = data.data.data.address;
          let pageCount = data.data.data.pageCount;
          //If there are no results, the postcode is not right.
          if (results.length === 0) {
            document.getElementById("error_message").innerHTML =
              "No Hackney location found. Please amend your search.";
            document.getElementById("addresses").innerHTML = "";
            document.getElementById("address-details").innerHTML = "";
          } else {
            //If there are results from the addresses proxy, we list them.
            //first, replace list element with a clone of itself, in order to remove previous listeners
            //let listElement = document.getElementById("addresses");
            document
              .getElementById("addresses")
              .replaceWith(
                document.getElementById("addresses").cloneNode(true),
              );
            //now fill the list
            document.getElementById("addresses").innerHTML =
              "<div class='govuk-form-group lbh-form-group'>" +
              "<select class='govuk-select govuk-!-width-full lbh-select' id='selectedAddress' name='selectedAddress'>";

            document.getElementById("selectedAddress").innerHTML =
              "<option disabled selected value> Select a location from the list </option>";
            for (let index = 0; index < results.length; ++index) {
              //if (results[index].addressStatus == 'Approved' && (results[index].usagePrimary == 'Commercial' || results[index].usagePrimary == 'Dual Use')){
              if (results[index].commercialOccupier) {
                document.getElementById("selectedAddress").innerHTML +=
                  "<option value='" +
                  results[index].UPRN +
                  "/" +
                  results[index].singleLineAddress +
                  "/" +
                  results[index].usageDescription +
                  "/" +
                  results[index].ward +
                  "'>" +
                  results[index].commercialOccupier +
                  " - " +
                  results[index].singleLineAddress +
                  "</option>";
              } else {
                document.getElementById("selectedAddress").innerHTML +=
                  "<option value='" +
                  results[index].UPRN +
                  "/" +
                  results[index].singleLineAddress +
                  "/" +
                  results[index].usageDescription +
                  "/" +
                  results[index].ward +
                  "'>" +
                  results[index].singleLineAddress +
                  "</option>";
              }
              //}
            }

            //load more pages of results if needed
            if (pageCount > 1) {
              for (let pgindex = 2; pgindex <= pageCount; ++pgindex) {
                loadAddressAPIPageViaProxy(
                  APIQueryString,
                  address_input,
                  pgindex,
                );
              }
            }

            //close list of addresses
            document.getElementById("addresses").innerHTML += "</select></div>";

            //capture the change event - when an address is selected - we load the list of results using the UPRN selected.
            document
              .getElementById("addresses")
              .addEventListener("change", (event) => {
                //get the selected UPRN and address details from the list of addresses
                let selectedAddressDetails = document
                  .querySelector("#selectedAddress")
                  .value.split("/");
                let selectedUPRN = selectedAddressDetails[0];

                loadRegisterInfo(selectedUPRN);
                document.getElementById("results").innerHTML = "";
              });
            window.scrollBy(0, 50);
          }
        }
      })
      .catch((error) => {
        console.log(error);
        document.getElementById("error_message").innerHTML =
          "Sorry, an error occured while retrieving locations";
        document.getElementById("addresses").innerHTML = "";
      });
  }
}

//function to add one page of results to the options list
function loadAddressAPIPageViaProxy(APIQueryString, address_input, pg) {
  let results = null;
  let full_address = null;
  let UPRN = null;
  fetch(APIQueryString + `&page=${pg}`, {
    method: "get",
  })
    .then((response) => response.json())
    .then((data) => {
      results = data.data.data.address;

      for (let index = 0; index < results.length; ++index) {
        //if (results[index].addressStatus == 'Approved' && (results[index].usagePrimary == 'Commercial' || results[index].usagePrimary == 'Dual Use')){
        if (results[index].commercialOccupier) {
          document.getElementById("selectedAddress").innerHTML +=
            "<option value='" +
            results[index].UPRN +
            "/" +
            results[index].singleLineAddress +
            "/" +
            results[index].usageDescription +
            "/" +
            results[index].ward +
            "'>" +
            results[index].commercialOccupier +
            " - " +
            results[index].singleLineAddress +
            "</option>";
        } else {
          document.getElementById("selectedAddress").innerHTML +=
            "<option value='" +
            results[index].UPRN +
            "/" +
            results[index].singleLineAddress +
            "/" +
            results[index].usageDescription +
            "/" +
            results[index].ward +
            "'>" +
            results[index].singleLineAddress +
            "</option>";
        }
        //}
      }
    });
}

function loadRegisterInfo(selectedUPRN) {
  const url = `${process.env.GEOSERVER_URL}?service=WFS&version=1.0.0&request=GetFeature&outputFormat=json&typeName=licensing_act_2003_premises&cql_filter=uprn='${selectedUPRN}'`;

  axios.get(url)
    .then((res) => {
      const resultsContainer = document.getElementById("results");

      // 1. DATA VALIDATION
      if (res.data.numberReturned === 0) {
        resultsContainer.innerHTML = '<span class="govuk-error-message lbh-error-message">No license found at this location. <br> Note: data is under review and will be added gradually. If you can&#39;t find the information you are looking for, please contact us at licensing@hackney.gov.uk.</span>';
        return;
      }

      if (res.data.numberReturned > 1) {
        resultsContainer.innerHTML = '<span class="govuk-error-message lbh-error-message">There are multiple licenses associated to this address. Please contact us at licensing@hackney.gov.uk.</span>';
        return;
      }

      // 2. INITIALIZE PAGE
      resultsContainer.innerHTML = '<p class="loading-text"> Retrieving information...</p>';
      resultsContainer.scrollIntoView({ block: "nearest" });
      
      let textSection = "<h3>License details: </h3>";
      const featureProperties = res.data.features[0].properties;

      // 3. BUILD SUMMARY LIST (Main Details)
      textSection += `<dl class="govuk-summary-list lbh-summary-list">`;

      if (featureProperties.premises_name) {
        textSection += `<div class="govuk-summary-list__row"><dt class="govuk-summary-list__key">Premises name</dt><dd class="govuk-summary-list__value">${featureProperties.premises_name}</dd></div>`;
      }
      if (featureProperties.premises_full_address) {
        textSection += `<div class="govuk-summary-list__row"><dt class="govuk-summary-list__key">Premises address</dt><dd class="govuk-summary-list__value">${featureProperties.premises_full_address}</dd></div>`;
      }
      if (featureProperties.ward) {
        textSection += `<div class="govuk-summary-list__row"><dt class="govuk-summary-list__key">Ward</dt><dd class="govuk-summary-list__value">${featureProperties.ward}</dd></div>`;
      }
      if (featureProperties.licence_number) {
        textSection += `<div class="govuk-summary-list__row"><dt class="govuk-summary-list__key">Licence number</dt><dd class="govuk-summary-list__value">${featureProperties.licence_number}</dd></div>`;
      }

      // Licence Holder Logic
      if (featureProperties.licence_holder_1_full_line) {
        let holders = featureProperties.licence_holder_1_full_line;
        if (featureProperties.licence_holder_2_full_line) holders += `<br>${featureProperties.licence_holder_2_full_line}`;
        if (featureProperties.licence_holder_3_full_line) holders += `<br>${featureProperties.licence_holder_3_full_line}`;
        
        textSection += `<div class="govuk-summary-list__row"><dt class="govuk-summary-list__key">Premises licence holder(s)</dt><dd class="govuk-summary-list__value">${holders}</dd></div>`;
      }

      if (featureProperties.designated_premises_supervisor) {
        textSection += `<div class="govuk-summary-list__row"><dt class="govuk-summary-list__key">Designated premises supervisor (DPS)</dt><dd class="govuk-summary-list__value">${featureProperties.designated_premises_supervisor}</dd></div>`;
      }
      if (featureProperties.date_granted) {
        textSection += `<div class="govuk-summary-list__row"><dt class="govuk-summary-list__key">Date granted</dt><dd class="govuk-summary-list__value">${featureProperties.date_granted}</dd></div>`;
      }

      // Licence Status with Tag logic
      if (featureProperties.licence_status) {
        const redStatuses = ["Surrendered", "Revoked", "Lapsed", "Deferred", "In Mediation", "In-consultation", "Invalid", "Invalid code", "Sub-Committee", "Suspended", "Unknown/empty"];
        const tagColor = redStatuses.includes(featureProperties.licence_status) ? "lbh-tag--red" : "lbh-tag--green";
        
        textSection += `<div class="govuk-summary-list__row">
          <dt class="govuk-summary-list__key">Licence status</dt>
          <dd class="govuk-summary-list__value"><span class="govuk-tag lbh-tag ${tagColor}">${featureProperties.licence_status}</span></dd>
        </div>`;
      }

      textSection += `</dl>`; // Close Summary List

      // 4. BUILD ACTIVITIES TABLE
      const inactiveStatuses = ["Surrendered", "Revoked", "Lapsed", "Invalid"];
      if (!inactiveStatuses.includes(featureProperties.licence_status)) {
        textSection += `<br><br>
          <table class="govuk-table lbh-table">
            <caption class="govuk-table__caption lbh-heading-h3">
              The times the licence authorises the carrying out of licensable activities:
            </caption>
            <tbody class="govuk-table__body">`;

        /**
         * Helper function to build a multi-column row
         * This mirrors your original logic of checking time1, time2, time3
         */
        const buildActivityRow = (label, props) => {
          // props = { t1, l1, t2, l2, t3, l3 }
          if (!props.t1) return "";

          let row = `<tr class="govuk-table__row">
            <th scope="row" class="govuk-table__header">${label}</th>
            <td class="govuk-table__cell govuk-table__cell--numeric">
              ${props.l1 ? props.l1 + '<br>' : ''}${props.t1}
            </td>`;

          // Add second column if exists, otherwise empty cell
          row += `<td class="govuk-table__cell govuk-table__cell--numeric">
            ${props.t2 ? (props.l2 ? props.l2 + '<br>' : '') + props.t2 : ''}
          </td>`;

          // Add third column if exists, otherwise empty cell
          row += `<td class="govuk-table__cell govuk-table__cell--numeric">
            ${props.t3 ? (props.l3 ? props.l3 + '<br>' : '') + props.t3 : ''}
          </td>`;

          row += `</tr>`;
          return row;
        };

        // Add each activity using the multi-column helper
        textSection += buildActivityRow("Plays", { t1: featureProperties.playstime1, l1: featureProperties.playslocation1, t2: featureProperties.playstime2, l2: featureProperties.playslocation2, t3: featureProperties.playstime3, l3: featureProperties.playslocation3 });
        textSection += buildActivityRow("Exhibition of films", { t1: featureProperties.filmstime1, l1: featureProperties.filmslocation1, t2: featureProperties.filmstime2, l2: featureProperties.filmslocation2, t3: featureProperties.filmstime3, l3: featureProperties.filmslocation3 });
        textSection += buildActivityRow("Indoor sporting events", { t1: featureProperties.indoortime1, l1: featureProperties.sportslocation1, t2: featureProperties.indoortime2, l2: featureProperties.sportslocation2, t3: featureProperties.indoortime3, l3: featureProperties.sportslocation3 });
        textSection += buildActivityRow("Boxing", { t1: featureProperties.boxingtime1, l1: featureProperties.boxinglocation1, t2: featureProperties.boxingtime2, l2: featureProperties.boxinglocation2, t3: featureProperties.boxingtime3, l3: featureProperties.boxinglocation3 });
        textSection += buildActivityRow("Live music", { t1: featureProperties.livemusictime1, l1: featureProperties.livemusiclocation1, t2: featureProperties.livemusictime2, l2: featureProperties.livemusiclocation2, t3: featureProperties.livemusictime3, l3: featureProperties.livemusiclocation3 });
        textSection += buildActivityRow("Recorded music", { t1: featureProperties.recordemusictime1, l1: featureProperties.recordedlocation1, t2: featureProperties.recordemusictime2, l2: featureProperties.recordedlocation2, t3: featureProperties.recordemusictime3, l3: featureProperties.recordedlocation3 });
        textSection += buildActivityRow("Performances of dance", { t1: featureProperties.dancetime1, l1: featureProperties.perf_dance_location1, t2: featureProperties.dancetime2, l2: featureProperties.perf_dance_location2, t3: featureProperties.dancetime3, l3: featureProperties.perf_dance_location3 });
        textSection += buildActivityRow("Entertainment of a similar description to live music recorded music and performances of dance", { t1: featureProperties.other_enter_time1, l1: featureProperties.other_enter_location1, t2: featureProperties.other_enter_time2, l2: featureProperties.other_enter_location2, t3: featureProperties.other_enter_time3, l3: featureProperties.other_enter_location3 });
        textSection += buildActivityRow("Late night refreshment", { t1: featureProperties.latenighttime1, l1: featureProperties.latenightlocation1, t2: featureProperties.latenighttime2, l2: featureProperties.latenightlocation2, t3: featureProperties.latenighttime3, l3: featureProperties.latenightlocation3 });
        
        // Alcohol specific label including sale type (On/Off)
        const alcoholLabel = `Supply of alcohol<br>(${featureProperties.alcoholsaletype || ''})`;
        textSection += buildActivityRow(alcoholLabel, { t1: featureProperties.alcoholtimes1, l1: featureProperties.alcohollocation1, t2: featureProperties.alcoholtimes2, l2: featureProperties.alcohollocation2, t3: featureProperties.alcoholtimes3, l3: featureProperties.alcohollocation3 });
        
        // Opening times
        textSection += buildActivityRow("Opening times", { t1: featureProperties.openinghourstimes1, l1: "", t2: featureProperties.openinghourstimes2, l2: "", t3: featureProperties.openinghourstimes3, l3: "" });

        textSection += `</tbody></table>`;
      }

      // 5. BUILD CONDITIONS ACCORDION
      const formatConditionText = (text) => {
        if (!text) return "";
        return text
          .replace(/\u0001/g, '<br>') // Cleans up the database separator
          .replace(/\n/g, '<br>');    // Cleans up standard newlines
      };

      // We handle Mandatory categories individually so we can put extra spacing between them
      let mandatoryParts = [];
      if (featureProperties.mandatory_cond_alcohol_supply) {
        mandatoryParts.push(`<strong>Supply of Alcohol</strong><br>${formatConditionText(featureProperties.mandatory_cond_alcohol_supply)}`);
      }
      if (featureProperties.mandatory_cond_door_supervision) {
        mandatoryParts.push(`<strong>Door Supervision</strong><br>${formatConditionText(featureProperties.mandatory_cond_door_supervision)}`);
      }
      if (featureProperties.mandatory_cond_film_exhibition) {
        mandatoryParts.push(`<strong>Film Exhibition</strong><br>${formatConditionText(featureProperties.mandatory_cond_film_exhibition)}`);
      }

      // Join the parts with a double break for that "clean" spacing
      let mandatoryText = mandatoryParts.join('<br><br>');
      
      let annex2Text = formatConditionText(
        (featureProperties.opening_schedule || "") + 
        (featureProperties.responsible_authority || "")
      );
      
      let annex3Text = formatConditionText(featureProperties.committee_hearing || "");

      textSection += `<br><br><h3 class="lbh-heading-h3">Conditions</h3>
        <div class="govuk-accordion lbh-accordion" data-module="govuk-accordion" id="accordion-licence">`;

      // Mandatory Section
      textSection += `
        <div class="govuk-accordion__section">
          <div class="govuk-accordion__section-header">
            <h5 class="govuk-accordion__section-heading">
              <span class="govuk-accordion__section-button">Mandatory Conditions</span>
            </h5>
          </div>
          <div class="govuk-accordion__section-content">
            <p class="govuk-body">${mandatoryText || "No mandatory conditions specified."}</p>
          </div>
        </div>`;

      // Annex 2 Section (consistent with your clean look)
      if (annex2Text) {
        textSection += `
          <div class="govuk-accordion__section">
            <div class="govuk-accordion__section-header">
              <h5 class="govuk-accordion__section-heading">
                <span class="govuk-accordion__section-button">Annex 2 - Conditions consistent with Operating Schedule</span>
              </h5>
            </div>
            <div class="govuk-accordion__section-content">
              <p class="govuk-body">${annex2Text}</p>
            </div>
          </div>`;
      }

      // Annex 3 Section
      if (annex3Text) {
        textSection += `
          <div class="govuk-accordion__section">
            <div class="govuk-accordion__section-header">
              <h5 class="govuk-accordion__section-heading">
                <span class="govuk-accordion__section-button">Annex 3 - Conditions attached after Authority hearing</span>
              </h5>
            </div>
            <div class="govuk-accordion__section-content">
              <p class="govuk-body">${annex3Text}</p>
            </div>
          </div>`;
      }

      textSection += `</div>`; // End Accordion

      // 6. FINAL RENDER & INITIALIZATION
      resultsContainer.innerHTML = textSection;

      const accordionElem = document.querySelector('[data-module="govuk-accordion"]');
      if (accordionElem) {
        new Accordion(accordionElem).init();
      }

    })
    .catch((error) => {
      console.error('Fetch Error:', error);
      document.getElementById("error_message").innerHTML = 'Sorry, there was a problem retrieving the results for this address.';
    });
}
